<template>
  <!-- Results -->
  <v-dialog :value="isOpen" @click:outside="closeDialog" scrollable max-width="1000">
    <v-card>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
        rounded
        height="6"
      ></v-progress-linear>
      <v-card-title class="pa-0 shadow-1">
        <v-img
          :src="require('@/assets/illustrations/bg_modal_card.svg')"
          cover
          position="left bottom"
          class="align-center"
          height="65px"
        >
          <v-card-title class="font-weight-medium primary--text">
            Resumen
          </v-card-title>
        </v-img>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="pb-0">
            <div class="py-0 px-3 d-flex">
              <p class="mb-0 mr-3">
                <span class="info--text">Origen:</span>
                {{ itemToResults.origin || "Sin datos" }}
              </p>
              <p class="mb-0 mr-3">
                <span class="info--text">Destino:</span>
                {{ itemToResults.destination || "Sin datos" }}
              </p>
              <p class="mb-0 mr-3">
                <span class="info--text">Duracion:</span>
                {{ itemToResults.duration | secondsToTimeFormat }}
              </p>
            </div>
            <audio style="width: 100%" controls preload="none">
              <source :src="RecordingToShow.wav" type="audio/wav" />
              <source :src="RecordingToShow.mp3" type="audio/mpeg" />
              <p>
                Tu navegador no implementa el elemento audio.
              </p>
            </audio>
          </v-col>
          <v-col cols="12" class="pt-0">
            <v-row justify="center">
              <v-col cols="12">
                <h5 class="primary--text font-weight-medium ma-0">
                  Detalles
                </h5>
              </v-col>
              <v-col cols="10" class="pa-0">
                <p class="ma-0">
                  Agente:&nbsp;
                  <span class="text-subtitle-1  text-capitalize text--primary">
                    {{ itemToResults.user.name }}
                  </span>
                </p>
              </v-col>

              <v-col cols="10" class="pa-0">
                <p class="ma-0">
                  Fecha:&nbsp;
                  <span class="text-subtitle-1  text-capitalize text--primary">
                    {{ itemToResults.date }}
                  </span>
                </p>
              </v-col>
              <v-col cols="10" class="pa-0">
                <p class="ma-0">
                  Observaciones:&nbsp;
                  <span class="text-subtitle-1  text-capitalize text--primary">
                    {{ itemToResults.observations }}
                  </span>
                </p>
              </v-col>

              <!-- <v-col cols="10" class="pa-0">
                  <p class="primary--text ma-0">
                    {{ `Grabacion: ${itemToResults.recordings}` }}
                  </p>
                </v-col> -->
              <v-col cols="12">
                <h5 class="primary--text font-weight-medium ma-0">
                  Respuestas
                </h5>
              </v-col>
            </v-row>

            <v-data-table
              :headers="tablaModal"
              :items="itemToResults.test_response"
              :items-per-page="-1"
              item-key="id"
              show-expand
              single-expand
              hide-default-footer
            >
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="text--secondary">
                  {{ item.observation || "Sin observaciones" }}
                </td>
              </template>
              <template
                v-slot:[`item.data-table-expand`]="{
                  item,
                  isExpanded,
                  expand,
                }"
              >
                <v-btn icon v-show="item.observation" @click="expand(!isExpanded)">
                  <v-icon>
                    {{ isExpanded ? "mdi-chevron-up" : "mdi-chevron-down" }}
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import recordingPathGenerator from "../Utils/recordingPathGenerator";

export default {
  props: {
    itemToResults: {
      type: Object,
      default: {},
    },
    recordingUrl: {
      type: String,
      default: "",
    },
    isOpen: {
      type: Boolean,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    tablaModal: [
      {
        text: "Pregunta",
        value: "question.name",
        width: "60%",
      },
      {
        text: "Respuesta",
        value: "answer.name",
        width: "20%",
      },
      {
        text: "Valor",
        value: "answer.value",
        width: "20%",
      },
      { text: "", value: "data-table-expand" },
    ],
  }),

  computed: {
    RecordingToShow() {
      return {
        wav: `http://${this.recordingUrl}${recordingPathGenerator(
          this.itemToResults.recordings
        )}`,
        mp3: `http://${this.recordingUrl}${recordingPathGenerator(
          this.itemToResults.recordings,
          true
        )}`,
      };
    },
  },

  methods: {
    closeDialog() {
      this.$emit("dialog:close");
    },
  },
};
</script>

<style></style>
